import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/site";

export default function HotTicker() {
  const loop = [...hotTopics, ...hotTopics];

  return (
    <section className="border-b border-background-200 bg-accent-500">
      <div className="container-x flex items-center gap-4 py-3">
        <span className="flex shrink-0 items-center gap-2 text-xs font-bold tracking-wide text-foreground-950">
          <span className="h-2 w-2 animate-pulse-dot rounded-full bg-primary-600"></span>
          今日热榜
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loop.map((topic, i) => (
              <Link
                key={`${topic.slug}-${i}`}
                to={`/archive/${topic.slug}`}
                className="whitespace-nowrap text-sm text-foreground-900 transition-colors hover:text-foreground-950"
              >
                {topic.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}